module.exports = __webpack_public_path__ + "static/media/sandbox-bank.cc9bf55a.svg";